import { Grid, Tooltip } from '@mui/material';
import { ColorPalette } from '../../store/config/types/ColorSpectrum';
import { DndTimeLineChartItem } from '../DndTimelineChart/DndTimelineChart';
import { formatMinutes } from '../../utils/string.helpers';
import { Typography } from '@material-ui/core';

interface TripDndItemSpacerProps {
  width: number;
  rowIndex?: number;
  item?: DndTimeLineChartItem;
  itemIndex?: number;
  activeTimePosition?: 'start' | 'center' | 'end' | 'space-between';
  optimizing?: boolean;
}

export default function TripDndItemSpacer({
  width,
  itemIndex,
  item,
  rowIndex,
  activeTimePosition = 'end',
  optimizing,
}: TripDndItemSpacerProps) {
  const idleRatio = item?.additionalInfo?.idleRatio ?? 0;
  const activePartWidth = width * (1 - idleRatio);
  const idleMinutes = (item?.additionalInfo?.totalMinutes ?? 0) * idleRatio;
  const activeMinutes = (item?.additionalInfo?.totalMinutes ?? 0) * (1 - idleRatio);
  const pIndex = item?.colorIndex ?? rowIndex ?? 0;
  const pColor = ColorPalette[pIndex % ColorPalette.length];

  return (
    <Tooltip
      title={
        activeMinutes > 1 ? (
          <Grid container gap={1}>
            <Typography variant="subtitle2" color="inherit">
              {formatMinutes(activeMinutes)}
            </Typography>
            {idleMinutes > 1 && (
              <Typography variant="subtitle2" color="primary">
                +{formatMinutes(idleMinutes)}
              </Typography>
            )}
          </Grid>
        ) : (
          ''
        )
      }
      placement="top"
      arrow
    >
      <div
        className={`dndt-row-spacer${itemIndex === 0 ? ' first' : ''}${optimizing ? ' optimizing' : ''}`}
        style={{
          justifyContent: activeTimePosition,
          backgroundColor: 'transparent',
          position: 'relative',
          height: 0,
          ...(itemIndex === 0
            ? { width, border: 'none' }
            : {
                width: optimizing && !width ? 8 : width,
                border: '3px dashed',
                borderLeft: 'none',
                borderRight: 'none',
                borderColor: pColor.main,
              }),
        }}
      >
        <span
          style={{
            display: 'inline-block',
            width: activePartWidth / 2,
            height: 7,
            marginTop: -3,
            borderWidth: 2,
            borderStyle: 'solid',
            backgroundColor: pColor.main,
            borderColor: pColor.dark40,
            borderLeft: 'none',
            borderRight: 'none',
          }}
        ></span>
        <span
          style={{
            display: 'inline-block',
            width: activePartWidth / 2,
            height: 7,
            marginTop: -3,
            borderWidth: 2,
            borderStyle: 'solid',
            backgroundColor: pColor.main,
            borderColor: pColor.dark40,
            borderLeft: 'none',
            borderRight: 'none',
          }}
        ></span>
      </div>
    </Tooltip>
  );
}
